import {Action} from 'redux';
import {call} from '@redux-saga/core/effects';
import {trackTimingEnd, trackTimingStart} from '@unifocus/js-utils';
import {hideMask, showMask} from '../maskhandler/MaskHandler';
import {showError} from '../errorhandler/GlobalErrorHandler';

const startTiming = (action: Action): string | null => {
   const anyAction = action as any;
   const metaData = anyAction.meta;

   if (metaData && metaData.analytics && metaData.analytics.category) {
      return trackTimingStart(metaData.analytics.category, action.type, metaData.analytics.label);
   }

   return null;
};

const stopTiming = (timingKey: string) => {
   trackTimingEnd(timingKey);
};

const isMaskingEnabled = (options?: SagaWrapperOptions): boolean => {
   if (options) {
      return options.disableMasking !== true;
   }

   return true;
};

const isSkipRefCheck = (options?: SagaWrapperOptions): boolean => {
   if (options) {
      return options.skipRefCheck !== undefined && options.skipRefCheck;
   }

   return false;
};

const sagaWrapperImpl = (sagaToWrap: any, options?: SagaWrapperOptions) => {
   return function* (action: Action) {
      try {
         const maskingEnabled = isMaskingEnabled(options);
         const skipRefCheck = isSkipRefCheck(options);
         let timingKey = null;

         try {
            timingKey = startTiming(action);

            if (maskingEnabled) {
               showMask(skipRefCheck);
            }

            yield* sagaToWrap(action);
         }
         finally {
            if (maskingEnabled) {
               hideMask(skipRefCheck);
            }

            if (timingKey) {
               stopTiming(timingKey);
            }
         }
      }
      catch (error) {
         console.error(error);

         try {
            yield call(showError as any, error);

            if (options && options.onErrorAcknowledged) {
               yield* options.onErrorAcknowledged(action);
            }
         }
         catch (ignored) {
            // ignore errors
         }
      }
   };
};

export interface SagaWrapperOptions {
   onErrorAcknowledged?: any;
   disableMasking?: boolean;
   skipRefCheck?: boolean;
}

export const saga = (sagaToWrap: any, options?: SagaWrapperOptions) => {
   return sagaWrapperImpl(sagaToWrap, options);
};

export const formSaga = (sagaToWrap: any, options?: SagaWrapperOptions) => {
   return sagaWrapperImpl(sagaToWrap, options || {disableMasking: true});
};
